module.exports = __webpack_public_path__ + "static/media/field-hockey.3726a0dc.svg";